<div class="main-content">
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">

                <ng-container *ngIf="loading">
                    <div class="loading text-center">
                        <br />
                        <img style="padding-top:50px;" src="../../../assets/img/gif/loading.gif" alt="Alternate Text" />
                        <br />
                        <p>Loading, please wait...</p>
                    </div>
                </ng-container>

                <ng-container *ngIf="!loading">

                    <div class="d-sm-flex align-items-center justify-content-between mb-4 margin-bottom headerTitle">
                        <h1 class="h3 mb-0 text-gray-800">Users</h1>
                        <div class="btns-container">

                            <!--<a (click)="showResetPasswordModal()" class="d-none d-sm-inline-block btn btn-sm shadow-sm margin-right-5" [ngClass]="{'btn-primary': canReset, 'btn-gray': !canReset}">
                                <i class="fas fa-unlock-alt text-white-50"> <span class="button-text"> Reset Password</span></i>
                            </a>
                            <a (click)="showUsersAssignAssessmentsModal()" class="d-none d-sm-inline-block btn btn-sm shadow-sm" [ngClass]="{'btn-primary': canAdd, 'btn-gray': !canAdd}">
                                <i class="fas fa-plus text-white-50"> <span class="button-text"> Assign Assessments</span></i>
                            </a>-->
                        </div>
                    </div>

                    <div class="card shadow">

                        <div class="container-fluid">
                            <div style="width: 100%; max-height: 400px; height:400px;">
                                <ag-grid-angular #agGrid
                                                 style="width: 100%; height: 100%;"
                                                 class="ag-theme-balham"
                                                 [enableFilter]="true"
                                                 [floatingFilter]="true"
                                                 [gridOptions]="gridOptions"
                                                 [rowData]="data"
                                                 [columnDefs]="dataHeaders"
                                                 [enableSorting]="true"
                                                 [enableColResize]="true"
                                                 (rowClicked)="onRowClicked($event)"
                                                 (gridReady)="onGridReady($event)"
                                                 [rowSelection]="'multiple'"
                                                 (selectionChanged)="onSelectionChanged($event)"
                                                 [rowMultiSelectWithClick]="true"
                                                 [overlayNoRowsTemplate]="overlayNoRowsTemplate">
                                </ag-grid-angular>
                                <div *ngIf="fetchingUsers" class="loading text-center" style="width: 100%; height:400px; position: absolute; display: flex; top: 0; right: 0; left: 0;" >
                                    <div style="margin: auto; border-radius: 10px;">
                                        <i class="fas fa-spinner fa-pulse" style="font-size: 50px;"></i>
                                    </div>
                                    
                                </div>
                            </div> 
                        </div>
                    </div>
                </ng-container>
            </div>
        </div>
    </div>
</div>

<!--assign assessments MODAL-->
<div class="modal fade" id="usersAssignAssessmentsModal" tabindex="-1" role="dialog" aria-hidden="true">
    <div class="modal-dialog modal-sm" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <div class="text-center">
                    <h2 class="modal-title text-center"><span class="capitalize">Assign Assessments</span></h2>
                </div>
                <button (click)="hideUsersAssignAssessmentsModal()" type="button" class="close" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>

            <div class="modal-body">
                <div class="row">
                    <div class="col-md-8">
                        <p>ELI Self Assessment</p>
                    </div>
                    <div class="col-md-4">
                        <input [(ngModel)]="quantity" inputmode="numeric" type="number" min="0" step="1" max="999" id="quantity" (keyup)="allowOnlyNumber($event)" /> 
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-8">
                        <p>ELI 360 Assessment</p>
                    </div>
                    <div class="col-md-4">
                        <input [(ngModel)]="quantity360" inputmode="numeric" type="number" min="0" step="1" max="999" id="quantity360" (keyup)="allowOnlyNumber($event)" />
                    </div>
                </div>
            </div>

            <div class="modal-footer">
                <input (click)="hideUsersAssignAssessmentsModal()" type="button" class="btn btn-secondary" name="close" value="Cancel" />
                <input type="button" [disabled]="quantity == 0 && quantity360 == 0" (click)="saveAssessmentAssignmentByAdmin()" class="btn btn-primary waves-effect" value="Ok" />
            </div>
        </div>
    </div>
</div>

<!--RESET PASSWORD MODAL-->
<div class="modal fade" id="resetPasswordModal" tabindex="-1" role="dialog" aria-hidden="true">
    <div class="modal-dialog" role="document"> 
        <div class="modal-content">
            <div class="modal-header">
                <div class="text-center">
                    <h2 class="modal-title text-center"><span class="capitalize">Reset Password</span></h2>
                </div>
                <button (click)="hideResetModal()" type="button" class="close" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>

            <div class="modal-body">

                <form [formGroup]="userForm" autocomplete="off">


                    <div class="row">
                        <div class="col-md-2 text-right noPadding">
                            <label>User: </label>
                        </div>
                        <div class="col-md-10">
                            <span>{{selected_client}}</span>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-2 text-right noPadding">
                            <label>Password: </label>
                        </div>
                        <div class="col-md-10">
                            <input passwordDirective class="form-control"
                                   type="password"
                                   id="password1"
                                   #_password1
                                   placeholder="Password"
                                   autocomplete="new-password"
                                   formControlName="password1"
                                   (keyup)="preventSpace(_password2.value, $event, 'password2')" />

                            <ng9-password-strength-bar [passwordToCheck]="_password1.value"
                                                       [barColors]="myColors"
                                                       (onStrengthChanged)="passwordValid($event)">
                            </ng9-password-strength-bar>
                            <p id="passWordText" style="font-size: 12px;">
                                Password must be 8-20 characters long and it must contain at least one number, one capital letter and one symbol.
                            </p>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-2 text-right noPadding">
                            <label>Confirm password: </label>
                        </div>
                        <div class="col-md-10">
                            <input passwordDirective class="form-control pass2"
                                   type="password"
                                   id="password2"
                                   #_password2
                                   placeholder="Confirm password"
                                   autocomplete="new-password"
                                   formControlName="password2"
                                   (keyup)="preventSpace(_password2.value, $event, 'password2')" />
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-offset-2 col-md-10">
                            <span id="errorPasswordMessage"></span>
                        </div>
                    </div>

                </form>

            </div>

            <div class="modal-footer">
                <input (click)="hideResetModal()" type="button" class="btn btn-secondary" name="close" value="Cancel" />
                <input (click)="resetPassword()" type="button"
                       class="btn btn-primary waves-effect" value="Save" />
            </div>
        </div>
    </div>
</div>

<!-- PAGINATOR -->
<div #customPaginator id="customPaginator" style="display: flex; flex-flow: column;">
    <hr style="width: 100%; margin: 0px; border-color: #0000003d">
    <nav aria-label="Page navigation" style="margin: auto;" [hidden]="loading || totalUsers === 0">
        <ul class="pagination" style="margin: 0;">
            <li style="width: 10px; padding-right: 5px; padding-left: 5px;">
                <span style="background-color: transparent; border: none; color: rgba(0, 0, 0, 0.54); font-size: 12px; font-family: inherit;">
                    {{((pageNumber - 1) * 25) + 1 < 0 ? 0 : ((pageNumber - 1) * 25) + 1}} to {{(pageNumber * pageSize) < totalUsers ? (pageNumber * pageSize) : totalUsers}} of {{totalUsers}}
                </span>
            </li>

            <li style="width: 10px; padding-right: 5px; padding-left: 5px;" (click)="firstPage()">
                <span style="cursor: pointer; background-color: transparent; border: none; color: rgba(0, 0, 0, 0.54); width: 16px; height: 16px; font-size: 14px; padding-right: 0px; padding-left: 0px;" aria-hidden="true">
                    <b style="color: rgba(0, 0, 0, 0.4);">|</b><i class="fas fa-chevron-left" style="color: rgba(0, 0, 0, 0.4);"></i>
                </span>
            </li>
            <li aria-label="Previous" style="width: 10px; padding-right: 5px; padding-left: 5px;" (click)="previousPage()">
                <span style="cursor: pointer; background-color: transparent; border: none; color: rgba(0, 0, 0, 0.54); width: 16px; height: 16px; font-size: 14px; padding-right: 0px; padding-left: 0px; margin-left: 5px;" aria-hidden="true">
                   <i class="fas fa-chevron-left" style="color: rgba(0, 0, 0, 0.4);"></i>
                </span>
            </li>
    
            <li style="width: 10px; padding-right: 5px; padding-left: 5px;">
                <span style="background-color: transparent; border: none; color: rgba(0, 0, 0, 0.54); font-size: 12px; font-family: inherit;">
                    Page {{pageNumber}} of {{totalPages}}
                </span>
            </li>
          
            <li aria-label="Next" style="width: 10px; padding-right: 5px; padding-left: 5px;" (click)="nextPage()">
                <span style="cursor: pointer; background-color: transparent; border: none; color: rgba(0, 0, 0, 0.54); width: 20px; height: 16px; font-size: 14px; padding-right: 0px; padding-left: 0px;" aria-hidden="true">
                    <i class="fas fa-chevron-right" style="color: rgba(0, 0, 0, 0.4);"></i>
                </span>
            </li>
            <li style="width: 10px; padding-right: 5px; padding-left: 5px;" (click)="lastPage()">
                <span style="cursor: pointer; background-color: transparent; border: none; color: rgba(0, 0, 0, 0.54); width: 16px; height: 16px; font-size: 14px; padding-right: 0px; padding-left: 0px;" aria-hidden="true">
                    <i class="fas fa-chevron-right" style="color: rgba(0, 0, 0, 0.4);"></i><b style="color: rgba(0, 0, 0, 0.4);">|</b>
                </span>                                            
            </li>
        </ul>
    </nav>
</div>
